module.exports = __webpack_public_path__ + "static-portal/img/news12-7.0ce5255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-7.jpg
// module id = iCjO
// module chunks = 4